__turbopack_context__.v({
  "accountButton": "PrimaryNavBar-module-scss-module__XYi-DG__accountButton",
  "accountModal": "PrimaryNavBar-module-scss-module__XYi-DG__accountModal",
  "accountSection": "PrimaryNavBar-module-scss-module__XYi-DG__accountSection",
  "actionsSection": "PrimaryNavBar-module-scss-module__XYi-DG__actionsSection",
  "cartBadge": "PrimaryNavBar-module-scss-module__XYi-DG__cartBadge",
  "container": "PrimaryNavBar-module-scss-module__XYi-DG__container",
  "greeting": "PrimaryNavBar-module-scss-module__XYi-DG__greeting",
  "greetingLine1": "PrimaryNavBar-module-scss-module__XYi-DG__greetingLine1",
  "greetingLine2": "PrimaryNavBar-module-scss-module__XYi-DG__greetingLine2",
  "iconButton": "PrimaryNavBar-module-scss-module__XYi-DG__iconButton",
  "logo": "PrimaryNavBar-module-scss-module__XYi-DG__logo",
  "logoIcon": "PrimaryNavBar-module-scss-module__XYi-DG__logoIcon",
  "logoImageDesktop": "PrimaryNavBar-module-scss-module__XYi-DG__logoImageDesktop",
  "logoImageMobile": "PrimaryNavBar-module-scss-module__XYi-DG__logoImageMobile",
  "logoSection": "PrimaryNavBar-module-scss-module__XYi-DG__logoSection",
  "menuButton": "PrimaryNavBar-module-scss-module__XYi-DG__menuButton",
  "mobileSearchSection": "PrimaryNavBar-module-scss-module__XYi-DG__mobileSearchSection",
  "primaryNavBar": "PrimaryNavBar-module-scss-module__XYi-DG__primaryNavBar",
  "searchAndActionsSection": "PrimaryNavBar-module-scss-module__XYi-DG__searchAndActionsSection",
  "searchSection": "PrimaryNavBar-module-scss-module__XYi-DG__searchSection",
  "separator": "PrimaryNavBar-module-scss-module__XYi-DG__separator",
  "storeSelectorSection": "PrimaryNavBar-module-scss-module__XYi-DG__storeSelectorSection",
});
